export default {
    review: {
        title: 'Document Review',
        loading: 'Loading document...',
        share: {
            title: 'Share document',
            tabs: {
                invite: 'Invite people',
                access: 'People with access',
                link: 'Get link',
            },
            inviteType: {
                receiver: 'Existing Receivers',
                email: 'Custom Email',
                addressbook: 'Address Book',
            },
            fields: {
                recipients: 'Recipients',
                recipientsPlaceholder: 'Search receivers...',
                email: 'Email',
                emailPlaceholder: 'enter@email.com',
                contacts: 'Address Book Contacts',
                contactsPlaceholder: 'Search contacts...',
                message: 'Message (optional)',
                messagePlaceholder: 'Add an optional message...',
            },
            actions: {
                send: 'Send',
                cancel: 'Cancel',
            },
            noInvites: 'No invites sent yet',
            revokeAccess: 'Revoke Access',
            resend: 'Resend',
            revoke: 'Revoke',
            generateLinkDescription: 'Generate a sharing link that allows anyone to access the document without authentication.',
            linkExpiration: 'Link Expiration',
            expirationOptions: {
                never: 'Never',
                '1day': '1 day',
                '7days': '7 days',
                '30days': '30 days',
            },
            permissions: {
                view: 'View',
                edit: 'Edit',
            },
            generateLink: 'Generate Link',
            shareLink: 'Share Link',
            copy: 'Copy',
            copied: 'Copied!',
            linkWarning: 'Anyone with this link can access the document. Only share it with trusted people.',
            generateNewLink: 'Generate New Link',
        },
        triage: {
            title: 'Document Triage',
            subtitle: 'Container',
            goToContainerTriage: 'Go to Document Triage',
            resolveWithAI: 'Resolve with AI',
            tabs: {
                visual: 'Visual',
                raw: 'Raw Data',
            },
            visual: {
                document: 'Document',
                attributes: 'Extracted Attributes',
                values: 'Values',
            },
            raw: {
                json: 'JSON',
                highlightDiscrepancies: 'Highlight discrepancies',
            },
            attributes: {
                invoiceNumber: 'Invoice Number',
                amount: 'Amount',
                currency: 'Currency',
                issueDate: 'Issue Date',
                dueDate: 'Due Date',
                shipper: 'Shipper',
                consignee: 'Consignee',
                containerNumber: 'Container Number',
                blNumber: 'BL Number',
            },
            modal: {
                title: 'Resolving discrepancies with AI',
                analyzing: 'Analyzing and correcting extracted attributes…',
                completed: 'Resolution completed',
                allResolved: 'All discrepancies have been resolved. You can close this window to see the updated results.',
                close: 'Close',
            },
        },
        status: {
            pending: 'Pending',
            accepted: 'Accepted',
            rejected: 'Rejected',
        },
    },
    history: {
        title: 'Document Version History',
        subtitle: 'Document',
        container: 'Container',
        loading: 'Loading version history...',
        notFound: {
            title: 'Document not found',
            message: 'The requested document does not exist.',
            backToContainer: 'Back to container',
        },
        versions: {
            count: 'version',
            versions: 'versions',
        },
        info: {
            documentType: 'Document Type',
            currentVersion: 'Current Version',
            version: 'Version',
        },
        empty: {
            title: 'No version history',
            message: 'This document has no recorded version history.',
        },
        description: {
            uploadedBy: 'Uploaded by',
        },
    },
    triage: {
        title: 'Document Triage',
        subtitle: 'Container',
        loading: 'Loading document...',
        goToContainerTriage: 'Go to Container Triage',
        resolveWithAI: 'Resolve with AI',
        tabs: {
            visual: 'Visual',
            raw: 'Raw Data',
        },
        visual: {
            check: 'Check',
            ok: 'OK',
        },
        raw: {
            json: 'JSON',
            highlightDiscrepancies: 'Highlight discrepancies',
        },
        attributes: {
            invoiceNumber: 'Invoice Number',
            amount: 'Amount',
            currency: 'Currency',
            issueDate: 'Issue Date',
            dueDate: 'Due Date',
            shipper: 'Shipper',
            consignee: 'Consignee',
            containerNumber: 'Container Number',
            blNumber: 'BL Number',
        },
        modal: {
            title: 'Resolving discrepancies with AI',
            analyzing: 'Analyzing and correcting extracted attributes…',
            completed: 'Resolution completed',
            allResolved: 'All discrepancies have been resolved. You can close this window to see the updated results.',
            close: 'Close',
        },
    },
    drive: {
        title: 'Documents',
        myDrive: 'My Drive',
        unmappedFiles: 'Unmapped Files',
        showEmptyFolders: 'Show empty folders',
        search: {
            placeholder: 'Search documents, folders, containers...',
            noResults: 'No results found',
            results: 'Search Results',
        },
        breadcrumb: {
            home: 'My Drive',
        },
        view: {
            card: 'Card View',
            list: 'List View',
        },
        folder: {
            container: 'Container',
            customFolder: 'Custom Folder',
            documentsCount: '{{count}} document',
            documentsCount_plural: '{{count}} documents',
            create: 'Create Folder',
            open: 'Open',
            rename: 'Rename',
            delete: 'Delete',
            moveAction: 'Move',
            cannotDelete: 'Container folders cannot be deleted',
            cannotRename: 'Container folders cannot be renamed',
            move: {
                title: 'Move Folder',
                label: 'Select Destination Folder',
                root: 'Root (My Drive)',
                save: 'Move',
                cancel: 'Cancel',
            },
            createModal: {
                title: 'Create Folder',
                label: 'Folder Name',
                parentLabel: 'Parent Folder (optional)',
                save: 'Create',
                cancel: 'Cancel',
            },
        },
        upload: {
            title: 'Upload Documents',
            dropZone: 'Drag files here or click to select',
            success: 'Documents uploaded successfully',
        },
        document: {
            actions: {
                download: 'Download',
                rename: 'Rename',
                move: 'Move',
                share: 'Share',
                delete: 'Delete',
            },
            rename: {
                title: 'Rename Document',
                label: 'Name',
                save: 'Save',
                cancel: 'Cancel',
            },
            move: {
                title: 'Move Document',
                label: 'Select Container',
                save: 'Move',
                cancel: 'Cancel',
            },
            share: {
                title: 'Share Document',
                email: 'Email',
                permission: 'Permission',
                view: 'View',
                edit: 'Edit',
                comment: 'Comment',
                send: 'Send',
                cancel: 'Cancel',
            },
            delete: {
                title: 'Delete Document',
                message: 'Are you sure you want to delete this document? This action cannot be undone.',
                confirm: 'Delete',
                cancel: 'Cancel',
            },
        },
        unmapped: {
            title: 'Unmapped Files',
            description: 'Files that are not yet associated with a container',
            empty: {
                title: 'No unmapped files',
                message: 'All files are associated with a container.',
            },
            bulkActions: {
                selectAll: 'Select All',
                deselectAll: 'Deselect All',
                selectAllLabel: 'Select all files to associate them to a container:',
                associate: 'Associate to Container',
                selected: '{{count}} selected',
                selected_plural: '{{count}} selected',
            },
            associate: {
                title: 'Associate Files to Container',
                label: 'Select Container',
                save: 'Associate',
                cancel: 'Cancel',
            },
        },
        detail: {
            containerInfo: 'Container Information',
            versions: 'Versions',
            currentVersion: 'Current Version',
            viewVersion: 'View Version',
            download: 'Download',
            previewNotAvailable: 'Preview not available for this file type',
            notFound: 'Document not found',
            backToDocuments: 'Back to Documents',
            downloadConfirm: {
                title: 'Download File',
                message: 'This file cannot be viewed in the browser. Do you want to download it?',
                download: 'Download',
                cancel: 'Cancel',
            },
        },
    },
};
